var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-collapsible", {
    staticClass: "_tc--accent",
    attrs: { rounded: false },
    scopedSlots: _vm._u([
      {
        key: "trigger",
        fn: function ({ isExpanded }) {
          return [
            _c(
              "div",
              { staticClass: "_tc--accent" },
              [
                _c("base-icon", {
                  attrs: { name: isExpanded ? "chevron-up" : "chevron-down" },
                }),
                _vm._v(" "),
                !isExpanded
                  ? [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.showDetailsLabel) +
                          "\n            "
                      ),
                    ]
                  : [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.hideDetailsLabel) +
                          "\n            "
                      ),
                    ],
              ],
              2
            ),
          ]
        },
      },
      {
        key: "header-content",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "_flex _ai-c _gap-1" },
              [
                _c(
                  "base-text",
                  {
                    staticClass: "_cur-p _ttl _tc--accent",
                    attrs: {
                      as: "a",
                      href: _vm.formattedYourPledgeUrl,
                      level: "b2",
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.Resources.BackerCenter
                            .NotificationViewYourPledgeActionButton
                        ) +
                        "\n                "
                    ),
                    _c("base-icon", {
                      attrs: { name: "chevron-right", size: "sm" },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c("base-key-value-list", {
              staticClass: "_mt-2",
              attrs: { items: _vm.additionalInformationList },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }